import { ComponentProps, ReactNode } from 'react';
import { ActionIcon, ActionIconProps, Drawer, Stack } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Icon, Menu2 } from 'tabler-icons-react';

type SideMenuProps = {
  links: ({ close }: { close: () => void }) => ReactNode[];
  title?: ReactNode;
  variant?: ActionIconProps['variant'];
  color?: ActionIconProps['color'];
  iconColor?: ComponentProps<Icon>['color'];
  children?: ReactNode;
};

export const SideMenu = ({
  links,
  variant = 'filled',
  color = 'white',
  iconColor,
  children,
  title,
}: SideMenuProps) => {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Drawer
        opened={opened}
        position="right"
        size="100%"
        closeButtonProps={{ size: 'lg' }}
        onClose={close}
        title={title}
      >
        <Stack spacing="sm">{links({ close })}</Stack>
        {children}
      </Drawer>

      <ActionIcon variant={variant} color={color} size="lg" onClick={open}>
        <Menu2 size={24} strokeWidth={2} color={iconColor} />
      </ActionIcon>
    </>
  );
};
